import { Flex } from 'antd';
import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export type StyledProfileCardProps = {
  bannerUrl: string;
};

export const StyledProfileCard = styled.a`
  ${({ theme }) => {
    const { Color, Animation } = theme.Components.Skeleton;

    return `
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: center;
      text-decoration: none;
      .ant-skeleton > *:is(.ant-skeleton-input,.ant-skeleton-button,.ant-skeleton-avatar) {
        background: linear-gradient(90deg,
          ${Color.Dark} ${Animation.Gradient.Start}%,
          ${Color.Light} ${Animation.Gradient.Center}%,
          ${Color.Dark} ${Animation.Gradient.End}%);
        background-size: ${Animation.Background}% 100%;
      };
    `;
  }};
`;

export const StyledProfileCardBanner = styled.div<StyledProfileCardProps>`
  ${({ theme, bannerUrl }) => `
    display: flex;
    height: 60px;
    align-items: flex-start;
    gap: 2px;
    align-self: stretch;
    border-radius: ${utils.rem(theme.Spacing.Size.XSmall)};
    background: url(${bannerUrl}), lightgray 50%;
    background-size: cover;
    background-repeat: no-repeat;
  `}
`;

export const StyledProfileCardContent = styled(Flex)`
  ${({ theme }) => `
    flex-direction: column;
    align-items: center;
    gap: ${utils.rem(theme.Spacing.Size.XSmall)};
    margin-top: ${utils.rem(-theme.Spacing.Size.MediumLarge)};
  `}
`;

export const StyledProfileCardContentAvatar = styled.div<{
  isMobile: boolean;
}>`
  ${({ theme, isMobile }) => {
    const resultSize = isMobile ? theme.Spacing.Size.XXLarge : theme.Spacing.Size.XXXLarge;

    return `
    & .ant-avatar {
      border: ${utils.rem(theme.Border.Size.Large)} solid ${theme.Color.Neutrals.Paper};
      width: ${utils.rem(resultSize)};
      height: ${utils.rem(resultSize)};
      flex-direction: column;
      justify-content: center;
      align-items: center;
      & img {
        width: ${utils.rem(resultSize)};
        height: ${utils.rem(resultSize)};
      }
    };
  `;
  }}
`;

export const StyledProfileCardContentInformation = styled(Flex)`
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
  span {
    text-align: center;
  }
`;

export const StyledProfileSkeletonCardContent = styled(Flex)`
  ${({ theme }) => `
    flex-direction: column;
    align-items: center;
    gap: ${utils.rem(theme.Spacing.Size.XSmall)};
    margin-top: ${utils.rem(-theme.Spacing.Size.MediumLarge)};
    width: 100%;
  `}
`;

export const StyledProfileSkeletonCardAvatar = styled.div<{
  isMobile: boolean;
}>`
  ${({ theme, isMobile }) => `
    & .ant-skeleton .ant-skeleton-avatar {
      border: ${utils.rem(2)} solid ${theme.Color.Neutrals.Paper};
      width: ${utils.rem(isMobile ? theme.Spacing.Size.XXLarge : theme.Spacing.Size.XXXLarge)};
      height: ${utils.rem(isMobile ? theme.Spacing.Size.XXLarge : theme.Spacing.Size.XXXLarge)};
      background-color: ${theme.Color.Neutrals.Paper}};
    }
  `}
`;

export const StyledProfileSkeletonCardText = styled.div`
  ${({ theme }) => `
    display: flex;
    width: 100%;
    justify-content: center;
    & .ant-skeleton .ant-skeleton-input {
        height: ${utils.rem(theme.Spacing.Size.MediumSmall)};
    }
  `}
`;
